'use client'

import { MultiChoiceWordQuestion } from '@entities/lesson'

import { Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  question: MultiChoiceWordQuestion
  userAnswer: string[]
  userAnswerIndex: number
  masterAnswer: string[]
  masterAnswerIndex: number
  aiExplanation: string
  masterHighlight: number[]
}

export const WrongMultiChoiceWordToastDescription = ({
  question,
  userAnswer,
  userAnswerIndex,
  masterAnswer,
  masterAnswerIndex,
  aiExplanation,
}: Props) => {
  return (
    <VStack className="gap-4">
      <VStack className="gap-0.5">
        <Typography size="h6" className="font-medium text-white">
          {userAnswer.join(' ')} : {question.source.body.options[userAnswerIndex]}
        </Typography>
        <Typography size="h6" className="font-medium text-[#819DFF]">
          {masterAnswer.join(' ')} : {question.source.body.options[masterAnswerIndex]}
        </Typography>
      </VStack>
      <Typography size="h6" className="font-medium text-gray-400">
        {aiExplanation}
      </Typography>
    </VStack>
  )
}
